module.exports = __webpack_public_path__ + "assets/img_vegetarian.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_vegetarian.png
 ** module id = 138
 ** module chunks = 1
 **/